import {Button} from "react-bootstrap";
import React from "react";
import RowCard from "../../betting/RowCard";

export default (props) => {
    const {
        t,
        activeSubmit = true,
        handleSubmitBetting,
        resetBet
    } = props;

    return (
        <RowCard mainClass="lo5d-bet-btn align-items-end justify-content-center" bodyClass={`betting-h d-flex w-100`}>
            <div className="row align-items-start justify-content-between w-100">
                <div className="w-100">
                    <div className="d-flex justify-content-center w-100 m-auto">
                        <Button
                            id="clear"
                            className={`bg-danger border-0 m-btn-bet custom-btn w-100`}
                            onClick={resetBet}>
                            {t("buttons:clear")}
                        </Button>
                        <Button id="save"
                                className="bg-green border-0 m-btn-bet custom-btn w-100"
                                disabled={!activeSubmit}
                                onClick={() => handleSubmitBetting(false, [], true)}>
                            {t("buttons:save")}
                        </Button>
                    </div>
                </div>
            </div>
        </RowCard>
    );
}